export const PLAYER = {
  firstName: "Sherab",
  lastName: "Tamang",
  position: "Forward",
  number: "9",
  tagline:
    "A young forward built in the hills of Darjeeling — sharp on the ball, quick between the cones, and hungry for the next level.",
  bio: "A rising academy player currently training with Kickstart FC. Known for close control, agility, and a natural instinct in front of goal.",
  stats: [
    { label: "Years playing", value: "05" },
    { label: "Current Club", value: "KFC" },
    { label: "Position", value: "FWD" },
    { label: "Jersey", value: "09" },
  ],
  heroImage:
    "https://customer-assets.emergentagent.com/job_football-highlights-15/artifacts/dolzm2gl_b18fbb5d-79d9-47f6-a03e-a70185349765.jpg",
  contact: {
    email: "sherabtamang@gmail.com",
    phone: "+91 8918703077",
    phoneSecondary: "+91 8250994365",
    location: "Karnataka, India",
    socials: [
      { label: "Instagram", url: "https://instagram.com" },
      { label: "Transfermarkt", url: "https://transfermarkt.com" },
      { label: "LinkedIn", url: "https://linkedin.com" },
    ],
  },
};

export const EDUCATION = [
  {
    years: "2026",
    degree: "Class 6",
    institution: "United International School, Bangalore",
    description:
      "Current school — continuing academics alongside training at Kickstart FC.",
  },
  {
    years: "2025",
    degree: "Class 5",
    institution: "Vels Global School, Bangalore",
    description:
      "Moved to Bangalore to be closer to Kickstart FC's football development programme.",
  },
  {
    years: "2022 — 2024",
    degree: "Class 2 to Class 4",
    institution: "Delhi Public School, Siliguri",
    description:
      "Foundation years — balancing schoolwork with early football training in North Bengal.",
  },
  {
    years: "2018 — 2021",
    degree: "Play Group to Class 1",
    institution: "Little Bud Montessori School, Dagapur",
    description:
      "Where it all began — first classroom and first taste of the game.",
  },
];

export const CLUBS = [
  {
    name: "Kickstart FC",
    role: "Academy — Forward",
    period: "Present",
    location: "Bengaluru, Karnataka",
    stats: "Current Club",
    note: "Currently training and playing at Kickstart FC's youth setup in Bengaluru.",
  },
  {
    name: "Falcon FC",
    role: "Youth Squad",
    period: "Previously",
    location: "West Bengal, India",
    stats: "Youth",
    note: "Developed his game with Falcon FC before moving on to Kickstart.",
  },
  {
    name: "Darjeeling Football Association",
    role: "Grassroots",
    period: "Early years",
    location: "Darjeeling, West Bengal",
    stats: "Where it started",
    note: "First steps in organised football — representing the district at grassroots level.",
  },
];

export const HIGHLIGHTS = {
  videos: [
    {
      title: "Match highlights",
      meta: "Kickstart FC",
      src: "https://customer-assets.emergentagent.com/job_football-highlights-15/artifacts/2z0d0fx8_ScreenRecording_07-06-2026%2021-26-49_1.mp4",
      poster:
        "https://customer-assets.emergentagent.com/job_football-highlights-15/artifacts/dolzm2gl_b18fbb5d-79d9-47f6-a03e-a70185349765.jpg",
    },
    {
      title: "On the ball",
      meta: "Kickstart FC training",
      src: "https://customer-assets.emergentagent.com/job_football-highlights-15/artifacts/nxr36d1k_ScreenRecording_07-13-2026%2019-07-30_1.mp4",
      poster:
        "https://customer-assets.emergentagent.com/job_football-highlights-15/artifacts/yhyf3b7h_IMG_5276.jpg",
    },
    {
      title: "In action",
      meta: "Match play",
      src: "https://customer-assets.emergentagent.com/job_football-highlights-15/artifacts/frc70zt0_ScreenRecording_07-13-2026%2019-06-17_1.mp4",
      poster:
        "https://customer-assets.emergentagent.com/job_football-highlights-15/artifacts/kjoubpih_IMG_4626.webp",
    },
  ],
  images: [
    {
      url: "https://customer-assets.emergentagent.com/job_football-highlights-15/artifacts/p2r80tek_da90634c-a9b7-4a98-9b68-4c0d9f1f3b07.jpg",
      caption: "Match day — team line-up before kickoff",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_football-highlights-15/artifacts/yhyf3b7h_IMG_5276.jpg",
      caption: "Driving forward with the ball",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_football-highlights-15/artifacts/kjoubpih_IMG_4626.webp",
      caption: "On the training pitch — Bangalore",
    },
  ],
};
